import { render, staticRenderFns } from "./VopProviderPage.vue?vue&type=template&id=62de977c&scoped=true&"
import script from "./VopProviderPage.vue?vue&type=script&lang=js&"
export * from "./VopProviderPage.vue?vue&type=script&lang=js&"
import style0 from "./VopProviderPage.vue?vue&type=style&index=0&id=62de977c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62de977c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62de977c')) {
      api.createRecord('62de977c', component.options)
    } else {
      api.reload('62de977c', component.options)
    }
    module.hot.accept("./VopProviderPage.vue?vue&type=template&id=62de977c&scoped=true&", function () {
      api.rerender('62de977c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vopProvider/VopProviderPage.vue"
export default component.exports